import { render, staticRenderFns } from "./NewUniRequest.vue?vue&type=template&id=0aed212e&"
import script from "./NewUniRequest.vue?vue&type=script&lang=js&"
export * from "./NewUniRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports